import { useTranslation } from "react-i18next";
import { ContentPanel, PageBanner, UnorderedList } from "../components";
import { MedicalLogisticalServicesBanner } from "../images";

export const MedicalLogisticalServices = () => {
    const { t } = useTranslation();
    const keyCapabilities1 = t('medicalLogisticalServices.keyCapabilities1.list', { returnObjects: true }) as string[]
    const keyCapabilities2 = t('medicalLogisticalServices.keyCapabilities1.list', { returnObjects: true }) as string[]

    return (
        <div>
            <PageBanner image={MedicalLogisticalServicesBanner} title={t('medicalLogisticalServices.bannerTitle')} />

            <ContentPanel headerText={t('medicalLogisticalServices.header')}>
                <h4 className="text-xl mb-5">{t('generic.keyCapabilities')}</h4>

                <div className="text-1xl mb-1 font-bold">
                    <UnorderedList items={[t('medicalLogisticalServices.keyCapabilities1.header')]} />
                </div>

                <UnorderedList items={keyCapabilities1} hasCheckmark={false} />

                <div className="text-1xl mt-4 mb-1 font-bold">
                    <UnorderedList items={[t('medicalLogisticalServices.keyCapabilities2.header')]} />
                </div>

                <UnorderedList items={keyCapabilities2} hasCheckmark={false} />

                <h4 className="text-xl my-5">{t('generic.industriesServed')}</h4>
                <span className="text-white leading-relaxed">{t('medicalLogisticalServices.industriesServed')}</span>
            </ContentPanel>
        </div>
    )
}